import codeDataStore from "common/codedata/store/CodeDataStore";
import UI from "components/UI";
import configStore from "common/config/store/ConfigStore";
import userStore from "common/user/store/UserStore";
import TbSysTitle from "domain/main/sys/title/TbSysTitle";
import { observer } from "mobx-react";
import React from "react";

export interface UIInputTitleGroupProps {
  tbSysTitleList: TbSysTitle[];
  required?: boolean;
  readOnly?: boolean;
  autoFocus?: boolean;
  setFocus?: boolean;
  className?: string;
}

export default observer(UIInputTitleGroup);

function UIInputTitleGroup(props: UIInputTitleGroupProps) {
  const [showAllLocale, setShowAllLocale] = React.useState(false);

  if (!props.tbSysTitleList) {
    return null;
  }

  if (!codeDataStore.exists("/common/systemLocale")) {
    return null;
  }

  const systemLocaleList = codeDataStore.get("/common/systemLocale");

  if (props.tbSysTitleList.length === 1) {
    const tbSysTitle = props.tbSysTitleList[0];

    if (props.readOnly === true) {
      return <span className="form-control form-control-sm text-left">{tbSysTitle.getTitleCn()}</span>;
    }

    return (
      <>
        <UI.Input
          value={tbSysTitle.getTitleCn()}
          valueChanged={(value) => tbSysTitle.setTitleCn(value)}
          className={props.className}
          autoFocus={props.autoFocus === true}
          setFocus={props.setFocus === true}
          rules={["required"]}
          // bytes={{ maxByte: 500 }}
        />
        {/*{props.required === true && <UI.Validator   />}*/}
      </>
    );
  }

  const getLocaleNm = (localeCode) => {
    if (!systemLocaleList) {
      return localeCode;
    }

    for (let i = 0; i < systemLocaleList.length; i++) {
      if (systemLocaleList[i].code === localeCode) {
        return systemLocaleList[i].name;
      }
    }
  };

  const tbSysTitleList: TbSysTitle[] = [];

  if (!showAllLocale) {
    for (let i = 0; i < props.tbSysTitleList.length; i++) {
      const tbSysTitle = props.tbSysTitleList[i];

      if (tbSysTitle.getTitleLocale() === userStore.userModel?.getUserLocale()) {
        tbSysTitleList.push(tbSysTitle);
        break;
      }
    }
  } else {
    for (let i = 0; i < props.tbSysTitleList.length; i++) {
      const tbSysTitle = props.tbSysTitleList[i];

      if (tbSysTitle.getTitleLocale() === configStore.config?.defaultLocale) {
        tbSysTitleList.push(tbSysTitle);
      }
    }

    for (let i = 0; i < props.tbSysTitleList.length; i++) {
      const tbSysTitle = props.tbSysTitleList[i];

      if (tbSysTitle.getTitleLocale() !== configStore.config?.defaultLocale) {
        tbSysTitleList.push(tbSysTitle);
      }
    }
  }

  return (
    <div style={{ display: "table", tableLayout: "auto", width: "100%" }}>
      {tbSysTitleList.map((tbSysTitle, index) => {
        return (
          <div
            key={tbSysTitle.getTitleLocale()}
            style={{
              marginTop: index === 0 ? undefined : "2px",
            }}
          >
            <div
              style={{
                display: "table-cell",
                fontSize: "9px",
              }}
            >
              {tbSysTitle.getTitleLocale()}
            </div>
            <div
              style={{
                display: "table-cell",
                paddingLeft: "2px",
                paddingRight: "2px",
                width: "100%",
              }}
            >
              {props.readOnly === true ? (
                <span className="form-control form-control-sm text-left">{tbSysTitle.getTitleCn()}</span>
              ) : (
                <>
                  <UI.Input
                    value={tbSysTitle.getTitleCn()}
                    valueChanged={(value) => tbSysTitle.setTitleCn(value)}
                    className={props.className}
                    autoFocus={index === 0 && props.autoFocus === true}
                    setFocus={index === 0 && props.setFocus === true}
                    attrs={{
                      placeholder: getLocaleNm(tbSysTitle.getTitleLocale()),
                    }}
                    rules={["required"]}
                    // bytes={{ maxByte: 500 }}
                  />
                  {/*{props.required === true && <UI.Validator  />}*/}
                </>
              )}
            </div>
            <div style={{ display: "table-cell" }}>
              <span style={{ cursor: "pointer" }} onClick={() => setShowAllLocale(!showAllLocale)}>
                {!showAllLocale ? "▼" : "▲"}
              </span>
            </div>
          </div>
        );
      })}
    </div>
  );
}
